










import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUserCircle } from "react-icons/fa";
import { MdVerifiedUser } from "react-icons/md";
import { ImUserTie } from "react-icons/im";
import { HiOutlineMail } from "react-icons/hi";
import { IoCall } from "react-icons/io5";
import { ImLocation } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import lionDash from "./dash.png";
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import TeamPDFDocument from './TeamPDFDocument'; // Adjust path if needed
import { saveAs } from 'file-saver';
import { translateText } from "../Navbar/Navbar"; // ✅ use same translator as Home/ContentPage
import { FaArrowDown } from "react-icons/fa";

const pastelColors = [
  "#e6f7ff",
  "#f9fbe7",
  "#e8f5e9",
  "#fff3e0",
  "#f3e5f5",
  "#e0f7fa",
  "#fffde7",
];

const CARDS_PER_PAGE = 16;

const Indiadirectory = ({ selectedLang }) => {
  const [leaders, setLeaders] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(""); // For non-Multiple teams
  const [selectedTeams, setSelectedTeams] = useState(""); // For Multiple teams
  const [hoveredCardId, setHoveredCardId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDownloadingMaster, setIsDownloadingMaster] = useState(false);

  // 🔤 translated overlays (display-only; logic still uses original arrays)
  const [tLeaderFields, setTLeaderFields] = useState({}); // { [id]: {name, desegnation, location} }
  const [tTeamLabels, setTTeamLabels] = useState({});    // { [originalTeamName]: translatedLabel }

  const navigate = useNavigate();
  const lang = selectedLang || localStorage.getItem("selectedLang") || "en";

  useEffect(() => {
    axios
      .get("https://lcoiapi.emedha.in/appi/india_leadership")
      .then((res) => setLeaders(res.data))
      .catch((err) => console.error("API Error:", err));

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔁 Build translated overlays (DO NOT mutate or replace original data used by filters/grouping)
  useEffect(() => {
    let cancelled = false;

    async function buildTranslations() {
      if (!lang || lang === "en") {
        if (!cancelled) {
          setTLeaderFields({});
          setTTeamLabels({});
        }
        return;
      }

      // translate leader visible fields
      const entries = await Promise.all(
        (leaders || []).map(async (ldr) => {
          const out = {};
          if (ldr.name) out.name = await translateText(String(ldr.name), lang);
          if (ldr.desegnation) out.desegnation = await translateText(String(ldr.desegnation), lang);
          if (ldr.location) out.location = await translateText(String(ldr.location), lang);
          return [ldr.id, out];
        })
      );

      // translate team labels for display (keep originals for grouping)
      const teamSet = new Set(
        (leaders || []).map((l) => l.leadership_team || "Unknown")
      );
      const teamPairs = await Promise.all(
        Array.from(teamSet).map(async (team) => {
          const t = await translateText(String(team), lang);
          return [team, t];
        })
      );

      if (!cancelled) {
        setTLeaderFields(Object.fromEntries(entries));
        setTTeamLabels(Object.fromEntries(teamPairs));
      }
    }

    buildTranslations();
    return () => { cancelled = true; };
  }, [lang, leaders]);


  // =======================
  // Search ================
  //========================

  const [searchQuery, setSearchQuery] = useState("");

  // Filter leaders by search text
  const filteredLeaders = (leaders || []).filter((leader) => {
    const query = searchQuery.toLowerCase();
    return (
      leader.name?.toLowerCase().includes(query) ||
      leader.email?.toLowerCase().includes(query) ||
      leader.number?.toString().includes(query) ||
      leader.district?.toLowerCase().includes(query) ||
      leader.location?.toLowerCase().includes(query)
    );
  });


  const groupedLeaders = filteredLeaders.reduce((acc, leader) => {
    const team = leader.leadership_team || "Unknown";
    if (team.toLowerCase().startsWith("multiple district")) return acc;
    if (!acc[team]) acc[team] = [];
    acc[team].push(leader);
    return acc;
  }, {});

  const teamNames = Object.keys(groupedLeaders);


  const groupedMultipleLeaders = filteredLeaders.reduce((acc, leader) => {
    const team = leader.leadership_team || "Unknown";
    if (!team.toLowerCase().startsWith("multiple district")) return acc;
    if (!acc[team]) acc[team] = [];
    acc[team].push(leader);
    return acc;
  }, {});


  const teamNamess = Object.keys(groupedMultipleLeaders);

  // Paginate members (uses ORIGINAL groups)
  const currentMembers =
    selectedTeam && groupedLeaders[selectedTeam]
      ? groupedLeaders[selectedTeam].slice(
        (currentPage - 1) * CARDS_PER_PAGE,
        currentPage * CARDS_PER_PAGE
      )
      : [];

  const totalPages = selectedTeam
    ? Math.ceil(groupedLeaders[selectedTeam]?.length / CARDS_PER_PAGE)
    : selectedTeams
      ? Math.ceil(groupedMultipleLeaders[selectedTeams]?.length / CARDS_PER_PAGE)
      : 1;

  // Styles
  const getGridColumns = () => (windowWidth < 768 ? "1fr" : "1fr 1fr");

  const containerStyle = { padding: "2rem", fontFamily: "Arial, sans-serif", maxWidth: "1200px", margin: "0 auto", };
  const cardsContainerStyle = { display: "grid", gridTemplateColumns: getGridColumns(), gap: "20px", };
  const teamCardStyle = (bgColor, isHovered) => ({ backgroundColor: bgColor, borderRadius: "10px", padding: "20px", position: "relative", boxShadow: isHovered ? "0 10px 20px rgba(0,0,0,0.2)" : "0 4px 12px rgba(0,0,0,0.1)", cursor: "pointer", transition: "transform 0.3s ease, box-shadow 0.3s ease", display: "flex", alignItems: "center", justifyContent: "space-between", transform: isHovered ? "translateY(-5px)" : "none", minHeight: "100px", });
  const lionImageStyle = { position: "absolute", top: "0px", right: "0px", width: "80px", height: "80px", opacity: 1.3, zIndex: 1, };
  const teamNameStyle = { fontSize: "18px", fontWeight: "bold", color: "#333", margin: 0, zIndex: 2, };
  const memberCardStyle = (isHovered) => ({
    backgroundColor: "#fff", borderRadius: "10px", padding: "15px", boxShadow: isHovered ? "0 8px 16px rgba(0,0,0,0.2)" : "0 4px 8px rgba(0,0,0,0.1)",
    transition: "0.3s ease", transform: isHovered ? "translateY(-4px)" : "none", position: "relative", display: "flex",
    flexDirection: "row", flexWrap: "wrap", alignItems: "center", gap: "20px",
  });
  const districtBadge = {
    position: "absolute", top: "0px", left: "15px", backgroundColor: "#1c509c", fontWeight: 'bold', color: "#fff",
    padding: "5px 10px", fontSize: "12px", borderRadius: "6px", zIndex: 5,
  };

  const imageWrapperStyle = { width: "80px", height: "80px", borderRadius: "50%", overflow: "hidden", backgroundColor: "#ddd", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, };
  const imageStyle = { width: "100%", height: "100%", objectFit: "cover", };
  const contentStyle = { flexGrow: 1, minWidth: "200px", };
  const nameStyle = { margin: "0 0 5px 0", fontSize: "18px", fontWeight: "bold", };
  const infoStyle = { margin: "4px 0", color: "#333", fontSize: "14px", };
  const clubStyle = { marginTop: "1px", fontStyle: "italic", color: "#007bff", fontSize: "13px", width: "100%", borderTop: "1px solid #e0e0e0", paddingTop: "8px", textAlign: "center", };
  const paginationContainer = { marginTop: "30px", textAlign: "center", };
  const paginationButton = (active) => ({ margin: "0 5px", padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #007bff", backgroundColor: active ? "#007bff" : "#fff", color: active ? "#fff" : "#007bff", cursor: "pointer", transition: "all 0.2s ease", });
  const backButtonStyle = { marginBottom: "20px", padding: "8px 14px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", };
  const masterDownloadButtonStyle = { marginBottom: "20px", marginLeft: "10px", padding: "8px 14px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", };

  const handleNavigate = () => {
    navigate('/leadersPage');
  };

  // const convertImageToBase64 = (url) => {
  //   return new Promise((resolve) => {
  //     const img = new Image();
  //     img.crossOrigin = "Anonymous";
  //     img.onload = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.naturalWidth;
  //       canvas.height = img.naturalHeight;
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);
  //       const dataUrl = canvas.toDataURL("image/png");
  //       resolve(dataUrl);
  //     };
  //     img.onerror = (err) => {
  //       console.error("Failed to load image:", url, err);
  //       resolve(null);
  //     };
  //     img.src = url;
  //   });
  // };

const convertImageToBase64 = (url) => {
  return new Promise((resolve) => {
    if (!url || typeof url !== "string") return resolve(null);

    const img = new Image();
    img.crossOrigin = "Anonymous";

    // Stop waiting if image takes longer than 2.5 seconds
    const timeout = setTimeout(() => {
      img.src = "";
      resolve(null);
    }, 2500);

    img.onload = () => {
      clearTimeout(timeout);
      try {
        const targetSize = 90; // 90x90 is sharp enough for 44x44 card on PDF
        const canvas = document.createElement("canvas");
        canvas.width = targetSize;
        canvas.height = targetSize;
        const ctx = canvas.getContext("2d");

        const minDim = Math.min(img.naturalWidth, img.naturalHeight);
        const sx = (img.naturalWidth - minDim) / 2;
        const sy = (img.naturalHeight - minDim) / 2;

        ctx.drawImage(img, sx, sy, minDim, minDim, 0, 0, targetSize, targetSize);
        const dataUrl = canvas.toDataURL("image/jpeg", 0.6); // 60% quality JPEG is ~8-12 KB
        resolve(dataUrl);
      } catch (err) {
        resolve(null);
      }
    };

    img.onerror = () => {
      clearTimeout(timeout);
      resolve(null);
    };

    img.src = url;
  });
};

// Process items in parallel chunks (e.g., 10 at a time)
const processInBatches = async (items, batchSize, fn) => {
  const results = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const resolvedBatch = await Promise.all(batch.map(fn));
    results.push(...resolvedBatch);
  }
  return results;
};


  const handleDownloadPDF = async (teamName, members) => {
    const updatedMembers = await Promise.all(
      members.map(async (member) => {
        if (member.image) {
          const base64Image = await convertImageToBase64(member.image);
          return { ...member, image: base64Image || null };
        }
        return member;
      })
    );

    const blob = await pdf(
      <TeamPDFDocument teamName={teamName} members={updatedMembers} />
    ).toBlob();

    saveAs(blob, `${teamName.replace(/\s+/g, "_")}_Team.pdf`);
  };


  // const handleMasterDownloadPDF = async () => {
  //   try {
  //     setIsDownloadingMaster(true);
  //     const updatedLeaders = await Promise.all(
  //       (leaders || []).map(async (member) => {
  //         if (member.image) {
  //           const base64Image = await convertImageToBase64(member.image);
  //           return { ...member, image: base64Image || null };
  //         }
  //         return member;
  //       })
  //     );

  //     const blob = await pdf(
  //       <TeamPDFDocument teamName="All Leadership Teams & Districts" members={updatedLeaders} />
  //     ).toBlob();

  //     saveAs(blob, "India_Directory_Master_Master_Report.pdf");
  //   } catch (error) {
  //     console.error("Master PDF generation error:", error);
  //   } finally {
  //     setIsDownloadingMaster(false);
  //   }
  // };


const handleMasterDownloadPDF = async () => {
  try {
    setIsDownloadingMaster(true);

    // 1. Remove empty placeholder records before network downloading images
    const activeLeaders = (leaders || []).filter(
      (m) => (m.name && m.name.trim() !== "") || (m.number && m.number.toString().trim() !== "")
    );

    // 2. Download and compress avatars in parallel batches of 15
    const updatedLeaders = await processInBatches(activeLeaders, 15, async (member) => {
      if (member.image) {
        const base64Image = await convertImageToBase64(member.image);
        return { ...member, image: base64Image };
      }
      return member;
    });

    // 3. Generate PDF containing all National Teams + All Multiple Districts (MD 316 to MD 3242)
    const blob = await pdf(
      <TeamPDFDocument teamName="All Leadership Teams & Districts" members={updatedLeaders} />
    ).toBlob();

    saveAs(blob, "India_Directory_Master_Report.pdf");
  } catch (error) {
    console.error("Master PDF generation error:", error);
  } finally {
    setIsDownloadingMaster(false);
  }
};


  const [translated, setTranslated] = useState({
    InternationalLeaders: "",
    BacktoDirectory: "",
    BacktoLeadershipTeams: "",
    BacktoMultipleDistrict: "",
    DownloadPDF: "",
    DownloadMasterPDF: "",
    Year: "",
  });

  useEffect(() => {
    async function translateAll() {
      const englishTexts = {
        InternationalLeaders: "India Directory",
        BacktoDirectory: " Back to Directory",
        BacktoLeadershipTeams: "Back to Leadership Teams",
        BacktoMultipleDistrict: "Back to Multiple District",
        DownloadPDF: "Download PDF",
        DownloadMasterPDF: "📥 Download Master Directory PDF",
        Year: "Year",
      };
      setTranslated({
        InternationalLeaders: await translateText(englishTexts.InternationalLeaders, selectedLang),
        BacktoDirectory: await translateText(englishTexts.BacktoDirectory, selectedLang),
        DownloadPDF: await translateText(englishTexts.DownloadPDF, selectedLang),
        DownloadMasterPDF: await translateText(englishTexts.DownloadMasterPDF, selectedLang),
        BacktoLeadershipTeams: await translateText(englishTexts.BacktoLeadershipTeams, selectedLang),
        BacktoMultipleDistrict: await translateText(englishTexts.BacktoMultipleDistrict, selectedLang),
        Year: await translateText(englishTexts.Year, selectedLang),
      });
    }

    translateAll();
  }, [selectedLang]);

  const getPaginationRange = (totalPages, currentPage) => {
    const pages = [];
    pages.push(1);
    if (totalPages > 1) pages.push(2);

    if (currentPage > 4) {
      pages.push("...");
    }

    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i > 2 && i < totalPages - 2) {
        pages.push(i);
      }
    }

    if (currentPage < totalPages - 3) {
      pages.push("...");
    }

    if (totalPages > 3) pages.push(totalPages - 2);
    if (totalPages > 2) pages.push(totalPages - 1);
    if (totalPages > 1) pages.push(totalPages);

    return [...new Set(pages)];
  };

  return (
    <div style={containerStyle}>
      <h4>{translated.InternationalLeaders}</h4>

      {!selectedTeam && !selectedTeams && (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <button style={backButtonStyle} onClick={() => { handleNavigate(); }}> ← {translated.BacktoDirectory} </button>
          <button style={masterDownloadButtonStyle} onClick={handleMasterDownloadPDF} disabled={isDownloadingMaster || leaders.length === 0} >{isDownloadingMaster ? "Generating Master PDF..." : translated.DownloadMasterPDF}</button>
        </div>
      )}

      {selectedTeam && (
        <button style={backButtonStyle} onClick={() => { setSelectedTeam(""); setSelectedTeams(""); setCurrentPage(1); }}> ← {translated.BacktoLeadershipTeams}</button>
      )}

      {!selectedTeam && !selectedTeams && (
        <>
          <div style={cardsContainerStyle}>
            {teamNames.map((team, index) => {
              const bgColor = pastelColors[index % pastelColors.length];
              const isHovered = hoveredCardId === team;
              return (
                <div key={team} style={teamCardStyle(bgColor, isHovered)} onClick={() => setSelectedTeam(team)} onMouseEnter={() => setHoveredCardId(team)} onMouseLeave={() => setHoveredCardId(null)}>
                  <h3 style={teamNameStyle}>{tTeamLabels[team] || team}</h3>
                  <img src={lionDash} alt="decorative" style={lionImageStyle} />
                </div>
              );
            })}
          </div>
        </>
      )}

      {selectedTeam && (
        <>
          <div style={{ textAlign: 'end' }}>
            <button style={backButtonStyle} onClick={() => handleDownloadPDF(selectedTeam, groupedLeaders[selectedTeam])} >📄<FaArrowDown />  {translated.DownloadPDF}</button>
          </div>

          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <input type="text" placeholder="Search by name, email, number, district..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ width: "60%", padding: "10px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px", }} />
          </div>

          <div style={cardsContainerStyle}>
            {currentMembers.map((leader) => {
              const isHovered = hoveredCardId === leader.id;
              const t = tLeaderFields[leader.id] || {};
              return (
                <div key={leader.id} style={memberCardStyle(isHovered)} onMouseEnter={() => setHoveredCardId(leader.id)} onMouseLeave={() => setHoveredCardId(null)}>
                  <div style={districtBadge}>{leader.district || "No District"}</div>
                  <div style={imageWrapperStyle}>
                    {leader.image ? (
                      <img src={leader.image} alt={leader.name} style={imageStyle} />
                    ) : (
                      <FaUserCircle style={{ fontSize: "60px", color: "#aaa" }} />
                    )}
                  </div>

                  <div style={contentStyle}>
                    <h3 style={nameStyle}>
                      <ImUserTie /> {t.name || leader.name || "Not Available"}
                    </h3>
                    <p style={infoStyle}>
                      <MdVerifiedUser /> {t.desegnation || leader.desegnation}
                    </p>
                    <p style={infoStyle}>
                      <a href={`mailto:${leader.email}`} style={{ textDecoration: "none", color: "#333" }}>
                        <HiOutlineMail style={{ marginRight: "5px" }} />
                        {leader.email}
                      </a>
                    </p>

                    <p style={infoStyle}>
                      <a href={`tel:${leader.number}`} style={{ textDecoration: "none", color: "#333" }}>
                        <IoCall style={{ marginRight: "5px" }} />
                        {leader.number}
                      </a>
                    </p>
                    <p style={infoStyle}>{leader.year}</p>
                  </div>

                  <div style={clubStyle}>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        (t.location || leader.location || "")
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      <ImLocation style={{ marginRight: "5px" }} />
                      {t.location || leader.location || "Location is not available"}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>

          {totalPages > 1 && (
            <div style={paginationContainer}>
              <button
                style={paginationButton(false)}
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              >
                Prev
              </button>

              {getPaginationRange(totalPages, currentPage).map((p, i) =>
                p === "..." ? (
                  <span key={i} style={{ margin: "0 5px" }}>...</span>
                ) : (
                  <button
                    key={p}
                    style={paginationButton(currentPage === p)}
                    onClick={() => setCurrentPage(p)}
                  >
                    {p}
                  </button>
                )
              )}

              <button
                style={paginationButton(false)}
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}

      <hr />

      {/* Multiple District Section */}
      {!selectedTeams && !selectedTeam && (
        <div style={cardsContainerStyle}>
          {teamNamess.map((team, index) => {
            const bgColor = pastelColors[index % pastelColors.length];
            const isHovered = hoveredCardId === team;
            return (
              <div
                key={team}
                style={teamCardStyle(bgColor, isHovered)}
                onClick={() => {
                  setSelectedTeams(team);
                  setCurrentPage(1);
                }}
                onMouseEnter={() => setHoveredCardId(team)}
                onMouseLeave={() => setHoveredCardId(null)}
              >
                <h3 style={teamNameStyle}>{tTeamLabels[team] || team}</h3>
                <img src={lionDash} alt="decorative" style={lionImageStyle} />
              </div>
            );
          })}
        </div>
      )}

      {/* {selectedTeams && (
        <>
          <button
            style={backButtonStyle}
            onClick={() => {
              setSelectedTeams("");
              setCurrentPage(1);
            }}
          >
            ← {translated.BacktoMultipleDistrict}
          </button>

          {(() => {
            const districtNumber = selectedTeams.match(/\d+/)?.[0];

            const filteredLeaders = leaders.filter((leader) => {
              const query = searchQuery.toLowerCase();
              return (
                leader.district?.toString().includes(districtNumber) &&
                (
                  leader.name?.toLowerCase().includes(query) ||
                  leader.email?.toLowerCase().includes(query) ||
                  leader.number?.toString().includes(query) ||
                  leader.district?.toLowerCase().includes(query) ||
                  leader.location?.toLowerCase().includes(query)
                )
              );
            });

            const paginatedLeaders = filteredLeaders.slice(
              (currentPage - 1) * CARDS_PER_PAGE,
              currentPage * CARDS_PER_PAGE
            );

            const totalPages = Math.ceil(filteredLeaders.length / CARDS_PER_PAGE);

            return (
              <>
                <div style={{ textAlign: 'end' }}>
                  <button
                    style={backButtonStyle}
                    onClick={() => handleDownloadPDF(selectedTeams, filteredLeaders)}
                  >
                    📄 {translated.DownloadPDF}
                  </button>
                </div>
                <div style={{ marginBottom: "20px", textAlign: "center" }}>
                  <input
                    type="text"
                    placeholder="Search by name, email, number, district..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      width: "70%",
                      padding: "12px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "15px",
                    }}
                  />
                </div>

                <div style={cardsContainerStyle}>
                  {paginatedLeaders.map((leader) => {
                    const isHovered = hoveredCardId === leader.id;
                    const t = tLeaderFields[leader.id] || {};
                    return (
                      <div
                        key={leader.id}
                        style={memberCardStyle(isHovered)}
                        onMouseEnter={() => setHoveredCardId(leader.id)}
                        onMouseLeave={() => setHoveredCardId(null)}
                      >
                        <div style={districtBadge}>
                          {leader.district || "No District"}
                        </div>

                        <div style={imageWrapperStyle}>
                          {leader.image ? (
                            <img
                              src={leader.image}
                              alt={leader.name}
                              style={imageStyle}
                            />
                          ) : (
                            <FaUserCircle style={{ fontSize: "60px", color: "#aaa" }} />
                          )}
                        </div>

                        <div style={contentStyle}>
                          <h3 style={nameStyle}>
                            <ImUserTie /> {t.name || leader.name || "Not Available"}
                          </h3>
                          <p style={infoStyle}>
                            <MdVerifiedUser /> {t.desegnation || leader.desegnation}
                          </p>

                          <p style={infoStyle}>
                            <a
                              href={`mailto:${leader.email}`}
                              style={{ textDecoration: "none", color: "#333" }}
                            >
                              <HiOutlineMail style={{ marginRight: "5px" }} />
                              {leader.email}
                            </a>
                          </p>

                          <p style={infoStyle}>
                            <a
                              href={`tel:${leader.number}`}
                              style={{ textDecoration: "none", color: "#333" }}
                            >
                              <IoCall style={{ marginRight: "5px" }} />
                              {leader.number}
                            </a>
                          </p>
                        </div>

                        <div style={clubStyle}>
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              (t.location || leader.location || "")
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "#007bff" }}
                          >
                            <ImLocation style={{ marginRight: "5px" }} />
                            {t.location || leader.location || "Location is not available"}
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {totalPages > 1 && (
                  <div style={paginationContainer}>
                    <button
                      style={paginationButton(false)}
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    >
                      Prev
                    </button>

                    {getPaginationRange(totalPages, currentPage).map((p, i) =>
                      p === "..." ? (
                        <span key={i} style={{ margin: "0 5px" }}>...</span>
                      ) : (
                        <button
                          key={p}
                          style={paginationButton(currentPage === p)}
                          onClick={() => setCurrentPage(p)}
                        >
                          {p}
                        </button>
                      )
                    )}

                    <button
                      style={paginationButton(false)}
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            );
          })()}
        </>
      )} */}
      {selectedTeams && (
  <>
    <button
      style={backButtonStyle}
      onClick={() => {
        setSelectedTeams("");
        setCurrentPage(1);
      }}
    >
      ← {translated.BacktoMultipleDistrict}
    </button>

    {(() => {
      // 1. Extract numeric code (e.g., "3234")
      const districtNumber = selectedTeams.match(/\d+/)?.[0] || "";

      // 2. Filter leaders belonging to this Multiple District
      const filteredLeaders = (leaders || []).filter((leader) => {
        // Skip dummy/blank placeholder records from API
        if (!leader.name && !leader.desegnation && !leader.email && !leader.number) {
          return false;
        }

        // Normalize text by removing spaces and hyphens for reliable matching
        const cleanDist = (leader.district || "").replace(/[\s-]/g, "").toUpperCase();
        const cleanTeam = (leader.leadership_team || "").replace(/[\s-]/g, "").toUpperCase();
        const targetNumber = districtNumber;

        // Check if district contains the number (e.g., "MD3234D1" contains "3234")
        // OR if leadership_team matches the selected team
        const matchesDistrict =
          cleanDist.includes(targetNumber) ||
          cleanTeam.includes(targetNumber);

        if (!matchesDistrict) return false;

        // Search query filter
        const query = searchQuery.toLowerCase();
        return (
          !query ||
          leader.name?.toLowerCase().includes(query) ||
          leader.email?.toLowerCase().includes(query) ||
          leader.number?.toString().includes(query) ||
          leader.district?.toLowerCase().includes(query) ||
          leader.location?.toLowerCase().includes(query)
        );
      });

      const paginatedLeaders = filteredLeaders.slice(
        (currentPage - 1) * CARDS_PER_PAGE,
        currentPage * CARDS_PER_PAGE
      );

      const totalPages = Math.ceil(filteredLeaders.length / CARDS_PER_PAGE);

      return (
        <>
          <div style={{ textAlign: "end" }}>
            <button
              style={backButtonStyle}
              onClick={() => handleDownloadPDF(selectedTeams, filteredLeaders)}
            >
              📄 {translated.DownloadPDF}
            </button>
          </div>

          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <input
              type="text"
              placeholder="Search by name, email, number, district..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                width: "70%",
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "15px",
              }}
            />
          </div>

          {filteredLeaders.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <h3>No members found for {selectedTeams}</h3>
            </div>
          ) : (
            <div style={cardsContainerStyle}>
              {paginatedLeaders.map((leader) => {
                const isHovered = hoveredCardId === leader.id;
                const t = tLeaderFields[leader.id] || {};
                return (
                  <div
                    key={leader.id}
                    style={memberCardStyle(isHovered)}
                    onMouseEnter={() => setHoveredCardId(leader.id)}
                    onMouseLeave={() => setHoveredCardId(null)}
                  >
                    <div style={districtBadge}>
                      {leader.district || "No District"}
                    </div>

                    <div style={imageWrapperStyle}>
                      {leader.image ? (
                        <img
                          src={leader.image}
                          alt={leader.name}
                          style={imageStyle}
                        />
                      ) : (
                        <FaUserCircle style={{ fontSize: "60px", color: "#aaa" }} />
                      )}
                    </div>

                    <div style={contentStyle}>
                      <h3 style={nameStyle}>
                        <ImUserTie /> {t.name || leader.name || "Not Available"}
                      </h3>
                      <p style={infoStyle}>
                        <MdVerifiedUser /> {t.desegnation || leader.desegnation}
                      </p>
                      {leader.email && (
                        <p style={infoStyle}>
                          <a
                            href={`mailto:${leader.email}`}
                            style={{ textDecoration: "none", color: "#333" }}
                          >
                            <HiOutlineMail style={{ marginRight: "5px" }} />
                            {leader.email}
                          </a>
                        </p>
                      )}
                      {leader.number && (
                        <p style={infoStyle}>
                          <a
                            href={`tel:${leader.number}`}
                            style={{ textDecoration: "none", color: "#333" }}
                          >
                            <IoCall style={{ marginRight: "5px" }} />
                            {leader.number}
                          </a>
                        </p>
                      )}
                      {leader.year && <p style={infoStyle}>{leader.year}</p>}
                    </div>

                    <div style={clubStyle}>
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          t.location || leader.location || ""
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "#007bff" }}
                      >
                        <ImLocation style={{ marginRight: "5px" }} />
                        {t.location || leader.location || "Location is not available"}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {totalPages > 1 && (
            <div style={paginationContainer}>
              <button
                style={paginationButton(false)}
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              >
                Prev
              </button>

              {getPaginationRange(totalPages, currentPage).map((p, i) =>
                p === "..." ? (
                  <span key={i} style={{ margin: "0 5px" }}>...</span>
                ) : (
                  <button
                    key={p}
                    style={paginationButton(currentPage === p)}
                    onClick={() => setCurrentPage(p)}
                  >
                    {p}
                  </button>
                )
              )}

              <button
                style={paginationButton(false)}
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              >
                Next
              </button>
            </div>
          )}
        </>
      );
    })()}
  </>
)}
    </div>
  );
};

export default Indiadirectory;